'use strict';

require('./reactWidgetsInit.less');

require('./reactWidgetsInit.scss');

/**
 * Inicializace react widgets.
 */

// import "react-widgets/lib/less/react-widgets.less";


require('moment/locale/cs.js');
var Moment = require('moment');
var momentLocalizer = require('react-widgets/lib/localizers/moment');

momentLocalizer(Moment);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZmllbGQvcmVhY3RXaWRnZXRzSW5pdC5qc3giXSwibmFtZXMiOlsicmVxdWlyZSIsIk1vbWVudCIsIm1vbWVudExvY2FsaXplciJdLCJtYXBwaW5ncyI6Ijs7QUFPQTs7QUFDQTs7QUFSQTs7OztBQUlBOzs7QUFNQUEsUUFBUSxxQkFBUjtBQUNBLElBQU1DLFNBQVNELFFBQVEsUUFBUixDQUFmO0FBQ0EsSUFBTUUsa0JBQWtCRixRQUFRLHFDQUFSLENBQXhCOztBQUVBRSxnQkFBZ0JELE1BQWhCIiwiZmlsZSI6InJlYWN0V2lkZ2V0c0luaXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEluaWNpYWxpemFjZSByZWFjdCB3aWRnZXRzLlxuICovXG5cbi8vIGltcG9ydCBcInJlYWN0LXdpZGdldHMvbGliL2xlc3MvcmVhY3Qtd2lkZ2V0cy5sZXNzXCI7XG5cblxuaW1wb3J0ICcuL3JlYWN0V2lkZ2V0c0luaXQubGVzcyc7XG5pbXBvcnQgJy4vcmVhY3RXaWRnZXRzSW5pdC5zY3NzJztcblxucmVxdWlyZSgnbW9tZW50L2xvY2FsZS9jcy5qcycpO1xuY29uc3QgTW9tZW50ID0gcmVxdWlyZSgnbW9tZW50Jyk7XG5jb25zdCBtb21lbnRMb2NhbGl6ZXIgPSByZXF1aXJlKCdyZWFjdC13aWRnZXRzL2xpYi9sb2NhbGl6ZXJzL21vbWVudCcpO1xuXG5tb21lbnRMb2NhbGl6ZXIoTW9tZW50KTtcbiJdfQ==